/**
 * id function
 */

const id = <T>(x: T): T => x

export {
  id,
}
